import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ProjectRecord } from '#shared/cms/records'

type ProjectValue = Omit<ProjectRecord, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New project - admin - Daniel Roe' })

async function save (value: ProjectValue) {
  await $fetch('/api/admin/projects', { method: 'POST', body: value })
  await navigateTo('/admin/projects')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminProjectForm = _resolveComponent("AdminProjectForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New project" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminProjectForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})